<template>
    <div class="guide-layer" :class="currentStepClass">
        <div class="guide-mask"></div>
        <div class="guide-goose"></div>
        <div class="guide-text">
            {{stepTextAry[currentStep-1]}}
        </div>
        <div class="guide-btn" @click="nextStep" :clstag="`A05R|clk_xsyd_${currentStep}`">
            知道了({{currentStep}}/3)
        </div>
        <div class="guide-jump-btn" @click="guideFinish" clstag="A05R|clk_xsyd_skip">跳过</div>
    </div>
</template>
<style rel="stylesheet/scss" lang="scss">
    .guide-layer {position: fixed;width: 100vw;height: 100vh;left: 0;top: 0;overflow: hidden;z-index: 30;animation: maskShow 0.3s 1 ease-out both;}
    .guide-mask {width: 1.5rem;height: 3rem;box-shadow: 0 0 20px rgba(0, 0, 0, .8) inset;outline: rgba(0, 0, 0, .8) 15rem solid;position: absolute;}
    .guide-text {width: 2.5rem;position: absolute;text-align: left;color: #fff;font-size: 0.16rem;}
    .guide-goose {position: absolute;width: 0.77rem;height: 0.98rem;background-image: url('#{$path}/home/guide-goose.png');@include singleBg;}
    .guide-btn {width: 1.5rem; height: 0.4rem;position: absolute;line-height: 0.4rem;border-radius: 0.3rem; font-size: 0.18rem;left: 50%;margin-left: -0.75rem;background-color: #8671FF;color: #fff;}
    .guide-jump-btn {position: absolute;top: 0.2rem;right: 0.1rem;width: 0.5rem;height: 0.2rem;border-radius: 0.2rem;border: 1px solid rgba(156, 57, 195, 1);color: #C559F0; font-size: 0.12rem;}
    .step1 {
        .guide-goose {bottom: 1.1rem;left: 0.2rem;}
        .guide-mask {width: 1.5rem;height: 3rem;left: 50%;bottom: 2.1rem;margin-left: -0.75rem;}
        .guide-text {bottom: 1.5rem;right: 0.2rem;}
        .guide-btn {bottom: 0.8rem;}
        }
    .step2 {
        .guide-goose {bottom: 1.6rem;left: 50%;margin-left: -0.3rem;transform: rotateY(180deg);}
        .guide-mask {width: 0.8rem;height: 1.2rem;left: 50%;bottom: 2.1rem;margin-left: -1.25rem;}
        .guide-text {width: 2rem;bottom: 2.8rem;right: 0.1rem;}
        .guide-btn {bottom: 0.8rem;}
        }
    .step3 {
        .guide-goose {top: 0.8rem;left: 1.8rem;transform: rotateY(180deg);}
        .guide-mask {width: 1.5rem;height: 0.6rem;left: 0;top: 0.05rem;}
        .guide-text {width: 1.3rem;top: 1rem;left: 0.5rem;}
        .guide-btn {top: 2.2rem;}
        }
</style>
<script type="javascript">
    export default {
        data() {
            return {
                currentStep: 1,
                currentStepClass: 'step1',
                stepTextAry: [
                    '我是您的专属小白鹅，每次计时结束我都将为您产一枚蛋',
                    '当蛋达到上限后 一定要及时来“提鹅收蛋”哦！',
                    '卖出鹅蛋得金币 可兑换各种好礼！'
                ]
            }
        },
        methods: {
            nextStep() {
                if (this.currentStep == 3) {
                    this.guideFinish();
                } else {
                    this.currentStep++;
                    this.currentStepClass = 'step' + this.currentStep;
                }
            },
            guideFinish() {
                this.$emit('guide-finish')
            }
        }
    }
</script>
